const InputEventTypes = {
    insertLineBreak: 'insertLineBreak',
};
export default InputEventTypes;
